<span [class]="currentCssClass">{{currentStatus}}</span>